import { v4 as uuidv4 } from "uuid";
import api from "./axiosInstance";

export function logError(error, additionalInfo = {}) {
  const errorId = uuidv4();
  const timestamp = new Date().toISOString();

  api
    .post("/logging/frontend/error", {
      errorId,
      timestamp,
      message: error.message || "Unknown error",
      stack: error.stack || "No stack trace",
      ...additionalInfo,
    })
    .catch((err) => console.error("Failed to log error:", err));
}
